/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfo_viewer = {
    readonly isReviewsEnabled: boolean | null;
    readonly " $refType": "PdpRespSidebarSellerInfo_viewer";
};
export type PdpRespSidebarSellerInfo_viewer$data = PdpRespSidebarSellerInfo_viewer;
export type PdpRespSidebarSellerInfo_viewer$key = {
    readonly " $data"?: PdpRespSidebarSellerInfo_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarSellerInfo_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isReviewsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    }
  ]
};
(node as any).hash = '321cdfee61404af5e789b9c50e2fb7fd';
export default node;
